import { Modal, Button } from "components/ui/BootstrapCompat";
import { Formik, Form } from "formik";
import CustomInput from "../CustomInput";
import { errorAdd, successAdd } from "helpers/sweetalert";
import { FaSave } from "react-icons/fa";
import { FaUser } from "react-icons/fa6";
import { useQueryClient } from "react-query";
import { userCreateOne } from "services/user.service";
import useLocalStorage from "helpers/useLocalStorage";

interface Props {
  open: boolean;
  onClose: () => void;
  businessId: string;
  callback?: (value: any) => void;
}

export default function PopUpCreateUser({ open, onClose, businessId, callback }: Props) {
  const queryClient = useQueryClient();
  const [token] = useLocalStorage("token", "");

  const onSubmit = async (values: any) => {
    try {
      const data = await userCreateOne(values, token, businessId);
      await queryClient.invalidateQueries(["user-list"]);
      callback?.(data);
      successAdd("ເພີ່ມຜູ້ໃຊ້ສຳເລັດ");
      onClose();
    } catch (error: any) {
      errorAdd(error?.response?.data?.message || "ເກີດຂໍ້ຜິດພາດ");
    }
  };

  return (
    <Modal show={open} onHide={onClose} keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="flex gap-2 items-center">
            <FaUser />
            ເພີ່ມຜູ້ໃຊ້
          </div>
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          name: "",
          email: "",
          phone: "",
          password: "",
          role: "user",
          status: "active",
        }}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <div className="flex flex-col gap-[10px]">
                <CustomInput
                  require
                  label="ຊື່ຜູ້ໃຊ້"
                  name="name"
                  type="text"
                  placeholder="-- ຊື່ຜູ້ໃຊ້ --"
                />
                <CustomInput
                  label="ອີເມວ"
                  name="email"
                  type="email"
                  placeholder="-- ອີເມວ --"
                />
                <CustomInput
                  label="ເບີໂທ"
                  name="phone"
                  type="text"
                  placeholder="-- ເບີໂທ --"
                />
                <CustomInput
                  require
                  label="ລະຫັດຜ່ານ"
                  name="password"
                  type="password"
                  placeholder="-- ລະຫັດຜ່ານ --"
                />
                <CustomInput
                  require
                  as="select"
                  label="ສິດ"
                  name="role"
                  onChange={(e: any) => setFieldValue("role", e.target.value)}
                >
                  <option value="user">ຜູ້ໃຊ້ທົ່ວໄປ</option>
                  <option value="admin">ຜູ້ດູແລລະບົບ</option>
                </CustomInput>
                <CustomInput
                  require
                  as="select"
                  label="ສະຖານະ"
                  name="status"
                  onChange={(e: any) => setFieldValue("status", e.target.value)}
                >
                  <option value="active">ເຄື່ອນໄຫວ</option>
                  <option value="inactive">ບໍ່ເຄື່ອນໄຫວ</option>
                </CustomInput>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                type="submit"
                className="w-full h-[54px] flex items-center gap-2 justify-center text-lg"
              >
                <FaSave className="w-[24px] h-[24px]" />
                ບັນທຶກ
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
